<template>
    <main class="admin">
        <div class="container">
            <RockMonthlyExport class="mb-6" />
            <RockEmployerCharges class="mb-5" />
        </div>
    </main>
</template>
<script>
import RockMonthlyExport from '@/components/RockMonthlyExport';
import RockEmployerCharges from '@/components/RockEmployerCharges.vue';

export default {
    name: 'RockAdmin',
    components: {
        RockMonthlyExport,
        RockEmployerCharges
    }
};
</script>
